import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height:auto;
  overflow-y:auto;
  overflow-x:hidden;
  padding: 0.5rem;
  flex-direction: column;

  /* .pa-R {
    padding-right: 0.5rem;
  } */

  ${({isHidden}) =>
    isHidden &&
    css`
      &{
        overflow: hidden;
      }
    `
  }

  ${({showCard}) =>
    !showCard &&
    css`
      &{
        visibility: hidden;
        overflow: hidden;
        height: 0px;
        padding: 0px;
      }
    `
  } 
`;

export const Title = styled.div`
  width: 100%;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  background-color: rgb(29, 134, 255);
  border-radius: 3px;
  cursor: pointer;

  div{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .name--ref{
    padding: 3px;
    line-height: 1.5;
    font-size: 12px;
    font-weight: bolder;
    margin-left: 5px;
    max-width:calc(100% - 20px);
  }

  span{
    display: flex;
    min-width:1.3rem;
    min-height: 1.3rem;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    font-weight: 500;
    margin-right: 0.5rem; 
  }

  .white{
    color: #000;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 50%;
  }

  .bigger{
    border-radius: 50px;
    padding: 0 0.5rem;
  }

  .icon{
    font-size: 1.75rem;
    margin-right: 1rem;
  }

  .rt-90{
    transform: rotate(90deg);
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  max-height: 500px;
  margin-top: .5rem;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: scroll;
  &::-webkit-scrollbar{
    width: 3px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: rgb(29, 134, 255);
  }
  ${({isHidden}) =>
    isHidden &&
    css`
      &{
        height: 0px;
        visibility: hidden;
      }
    `
  }  
`;